import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { config } from "./lib/api";
import { ApiContext } from "./lib/apiContext";
import { apiFetch, publicFetch, upload } from "./lib/fetcher";
import { router } from "./router";
import "./styles.css";

const { api_url } = await config();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ApiContext value={{ fetch: apiFetch, publicFetch, upload, apiUrl: api_url }}>
      <RouterProvider router={router} />
    </ApiContext>
  </StrictMode>,
);
